import React from 'react'
import cx from 'clsx'

import type { OrgStructureRecord } from '@pages/Team/Members/types'

const STATUS_STYLES: Record<string, string> = {
  active: 'bg-green-50 border-green-200 text-green-700',
  suspended: 'bg-red-50 border-red-200 text-red-600',
  deleted: 'bg-gray-100 border-gray-300 text-gray-500',
}

const STATUS_LABELS: Record<string, string> = {
  active: 'Active',
  suspended: 'Suspended',
  deleted: 'Deleted',
}

interface StatusProps {
  record: OrgStructureRecord
}

const Status: React.FC<StatusProps> = ({ record }) => {
  const status = record.status || 'active'
  return (
    <span
      className={cx(
        'text-xs font-medium px-2 py-0.5 rounded-full border',
        STATUS_STYLES[status] ?? STATUS_STYLES.active,
      )}
    >
      {STATUS_LABELS[status] ?? status}
    </span>
  )
}

export default React.memo(Status)
